import type { ColumnProps } from 'antd/lib/table';

import { SummaryGroupByLabelsMap } from '@/components/reporting/summary-group-by';
import {
  createAmountColumn,
  createStringColumn,
} from '@/components/table/columns';
import { summaryGroupByValueFormatter } from '@/resources/channels/performance-summary/shared/formatters';

export const commonEarningsTableConfig = (
  groupBy: string
): Array<ColumnProps<any>> => [
  createStringColumn({
    key: 'groupKey',
    render: summaryGroupByValueFormatter,
    title: SummaryGroupByLabelsMap[groupBy],
  }),
  createAmountColumn({
    align: 'right',
    key: 'totalPayout',
    title: 'Total Earnings',
    width: '50%',
  }),
];
